import React from 'react';
import Glyph from './Glyphs';

interface LocationFallbackProps {
  geoState: string;
  geoFrozen: boolean;
  onRetry?: () => void;
  onUseMap?: () => void;
}

export default function LocationFallback({ geoState, geoFrozen, onRetry, onUseMap }: LocationFallbackProps) {
  const show = geoState === 'denied' || geoFrozen || geoState === 'unavailable';

  if (!show) return null;

  return (
    <div className="glass-panel" role="status" style={{
      border: '1px solid var(--badge-amber-border)',
      background: 'rgba(255,170,0,0.08)',
      padding: 16,
      margin: '12px 16px',
      textAlign: 'center',
    }}>
      <div style={{ marginBottom: 8, color: 'var(--badge-amber-text, #FFAA00)' }} aria-hidden="true"><Glyph name="marker" size={32} /></div>
      <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, color: 'var(--text-primary)' }}>
        Location unavailable
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 12, lineHeight: 1.5 }}>
        {geoState === 'denied'
          ? 'Location access was denied. Enable it in your browser settings to see nearby gigs.'
          : geoFrozen
            ? 'GPS signal is weak. You can still browse gigs by town.'
            : 'Unable to determine your location. You can still browse all gigs.'}
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        {onRetry && (
          <button className="btn btn-sm" onClick={onRetry} style={{ fontSize: 11 }}>
            <Glyph name="refresh" size={14} /> Retry
          </button>
        )}
        {onUseMap && (
          <button className="btn btn-sm btn-primary" onClick={onUseMap} style={{ fontSize: 11 }}>
            <Glyph name="map" size={14} /> Browse Map
          </button>
        )}
      </div>
    </div>
  );
}
